import { strapiAPIUrl } from "src/api/config/config";

//! токен и url dev "Supplay Portal Access"
export const STRAPI_TOKEN = '';
export const BACKEND_URL = strapiAPIUrl;

